const en = {
  Header: {
    Home: "Home",
    Services: "Services",
    Projects: "Projects",
    ContactUs: "Contact Us",
    English: "English",
    Arabic: "Arabic",
  },
  DevelopmentProcess: {
    title: "Our Development Process",
    meetAndPlan: {
      title: "Meet & Plan",
      description: "Define Project Requirements",
    },
    design: {
      title: "Design",
      description: "Define Brand, Colours, and Typefaces",
    },
    development: {
      title: "Development",
      description: "Software Installation & Coding",
    },
    launch: {
      title: "Launch",
      description: "Multi-Browser & Device Testing and Ongoing Support Begins",
    },
  },
  Footer: {
    company: "Company",
    team: "our team",
    services: "Services",
    projects: "Projects",
    contactUs: "Contact Us",
    businessAnalysis: "Business Analysis",
    graphicDesign: "Graphic Design",
    uiUxDesign: "UI/UX Design",
    webDevelopment: "Web Development",
    mobileDevelopment: "Mobile Development",
    ai: "Artificial Intelligence",
    contactTitle: "Contact Us",
    phone: "+20 109 154 8180",
    email: "info@dramcode.top",
    socialMedia: {
      facebook: "Facebook",
      instagram: "Instagram",
      twitter: "Twitter",
      linkedin: "LinkedIn",
    },
  },
  HeroSection: {
    title: {
      we: "WE",
      implement: "IMPLEMENT",
      corporateSoftware: "CORPORATE SOFTWARE",
    },
    description:
      "We implement the corporate performance software to generate outstanding software products to take your business to the next level.",
    contactUs: "Contact Us",
  },
  SocialIcons: {
    followUs: "Follow . Us",
  },
  Services: {
    ourServices: "Our Services",
    readMore: "Read more",
    readLess: "Read less",
    servicesTitle: "Services Provided By the Company",
    About: "About Us",
    company: "Company",
    description:
      "We implement the corporate performance software to generate outstanding software products to take your business to an extra level.",
  },
  Project: {
    Title: "Our Projects",
  },
  Team: {
    Title: "Our Team",
  },
  ContactForm: {
    ContactUs: "Contact Us",
    Description:
      "We are here to help whether you have a question about our services or are ready to start a new software project.",
    NamePlaceholder: "Write your name here",
    PhonePlaceholder: "Write your phone here",
    TitlePlaceholder: "Write your topic title",
    DescriptionPlaceholder: "Write description",
    SendButton: "Send",
    PhoneMessage:
      "Please write the country code before the number. The number will work on WhatsApp.",
    SuccessTitle: "Success",
    SuccessMessage: "Form submitted successfully!",
    ErrorTitle: "Error",
    ErrorMessage: "Error submitting form",
    OkButton: "OK",
    ImageAlt: "Contact Image",
  },
  Projects: {
    All: "All",
    ProjectsWeDeveloped: "Projects we have developed",
    NoCategories: "No categories available.",
    NoProjects: "No projects available.",
    Loading: "Loading...",
    category: "Category",
  },
};

export default en;
